import { useEffect, useRef, useState } from 'react';
export const useClickOutside = (initialState = false) => {
    const [isActive, setIsActive] = useState(initialState);
    const ref = useRef(null);
    useEffect(() => {
        function handleClickOutside(e) {
            if (ref.current && !ref.current.contains(e.target)) {
                setIsActive(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, []);
    const activate = () => setIsActive(true);
    const deactivate = () => setIsActive(false);
    return {
        ref,
        isActive,
        setIsActive,
        activate,
        deactivate,
    };
};
